app.controller('popupStateOfHealthSimulationController', ['$scope', '$state', '$mdDialog', '$timeout', 'objectHelper', 'baseModel', 'applicationModel', 'stateOfHealthSimulationModel', 'visitCardId', 'icfDiagnoses',
    function ($scope, $state, $mdDialog, $timeout, objectHelper, baseModel, applicationModel, stateOfHealthSimulationModel, visitCardId, icfDiagnoses) {

        function checkIfContains(destination, source) {
            return destination.indexOf(source) != -1;
        }

        function groupSimulationEntriesByIcfType(simulationEntries) {
            $scope.dbsSimulationEntries = _.filter(simulationEntries, function(simulationEntry) {
                return ['d', 'b', 's'].indexOf(simulationEntry.icf.value.substr(0,1)) != -1;
            });
            $scope.eSimulationEntries = _.filter(simulationEntries, function(simulationEntry) {
                return simulationEntry.icf.value.substr(0,1) === 'e';
            });
        }

        function createSimulation() {
            var simulation = new StateOfHealthSimulationVO();

            simulation.suggestedIcd9s = [];
            simulation.simulationEntries = createSimulationEntries();

            return simulation;
        }

        function createSimulationEntries() {
            var simulationEntries = [];

            icfDiagnoses.forEach(function(icfDiagnosis) {
                var simulationEntry = new StateOfHealthSimulationIcfEntryVO();

                simulationEntry.icf = icfDiagnosis.icf;
                simulationEntry.inputQualifier = icfDiagnosis.firstQualifier;

                simulationEntries.push(simulationEntry);
            });

            return simulationEntries;
        }

        function clearSimulationResults() {
            _.each($scope.stateOfHealthSimulation.simulationEntries, function(simulationEntry) {
                simulationEntry.predictedQualifier = undefined;
                simulationEntry.simulationResult = undefined;
            });
        }

        function setData() {
            $scope.requestInProgress = true;
            $scope.forms = {
                stateOfHealthSimulationForm: null
            };
            $scope.stateOfHealthSimulation = undefined;
            $scope.dbsSimulationEntries = [];
            $scope.eSimulationEntries = [];
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on('$destroy', function (event) {
                $scope.requestInProgress = false;
            });

            $scope.$watch('stateOfHealthSimulation.selectedIcd9', function(newVal, oldVal) {
                if(!_.isUndefined(oldVal) && _.isEmpty(newVal)) {
                    clearSimulationResults();
                }
            });

            $scope.$on(Event.STATE_OF_HEALTH_SIMULATION.GET.SUCCESS, function(event, simulation) {
                if (_.isEmpty(simulation)) {
                    $scope.stateOfHealthSimulation = createSimulation();
                    stateOfHealthSimulationModel.suggest(visitCardId, $scope.stateOfHealthSimulation);
                } else {
                    $scope.stateOfHealthSimulation = simulation;
                    $scope.requestInProgress = false;
                }
                groupSimulationEntriesByIcfType($scope.stateOfHealthSimulation.simulationEntries);
            });

            $scope.$on(Event.STATE_OF_HEALTH_SIMULATION.SUGGEST.SUCCESS, function(event, simulation) {
                $scope.stateOfHealthSimulation = simulation;
                $scope.requestInProgress = false;
                groupSimulationEntriesByIcfType($scope.stateOfHealthSimulation.simulationEntries);
            });

            $scope.$on(Event.STATE_OF_HEALTH_SIMULATION.RUN.SUCCESS, function(event, simulation) {
                $scope.stateOfHealthSimulation = simulation;
                $scope.requestInProgress = false;
                groupSimulationEntriesByIcfType($scope.stateOfHealthSimulation.simulationEntries);
            });

            $scope.$on(Event.STATE_OF_HEALTH_SIMULATION.ADD_TO_DATA_SET.SUCCESS, function(event, simulation) {
                $scope.requestInProgress = false;
            });

            $scope.$on(Event.STATE_OF_HEALTH_SIMULATION.SUGGEST.ERROR, function(event, simulation) {
                $scope.requestInProgress = false;
            });

            $scope.$on(Event.STATE_OF_HEALTH_SIMULATION.RUN.ERROR, function(event, simulation) {
                $scope.requestInProgress = false;
            });

            $scope.$on(Event.STATE_OF_HEALTH_SIMULATION.ADD_TO_DATA_SET.ERROR, function(event, simulation) {
                $scope.requestInProgress = false;
            });
        }

        function setActions() {
            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.setSelectedIcd9 = function($event, procedure) {
                $event.preventDefault();
                $scope.stateOfHealthSimulation.selectedIcd9 = procedure;
            };

            $scope.start = function() {
                $scope.requestInProgress = true;
                stateOfHealthSimulationModel.run($scope.stateOfHealthSimulation);
            };

            $scope.refresh = function() {
                $scope.requestInProgress = true;
                $scope.stateOfHealthSimulation = createSimulation();
                groupSimulationEntriesByIcfType($scope.stateOfHealthSimulation.simulationEntries);
                stateOfHealthSimulationModel.suggest(visitCardId, $scope.stateOfHealthSimulation);
            };

            $scope.addToDataSet = function() {
                stateOfHealthSimulationModel.addToDataSet($scope.stateOfHealthSimulation);
            };

            $scope.getFlexValue = function(qualifier) {
                var num = 0;
                var icfNumber = parseInt(qualifier.value.substr(1,2), 10);
                if(icfNumber === 0) {
                    num = 20;
                }
                if(icfNumber === 1) {
                    num = 40;
                }
                if(icfNumber === 2) {
                    num = 60;
                }
                if(icfNumber === 3) {
                    num = 80;
                }
                if(icfNumber >= 4) {
                    num = 100;
                }
                return num;
            };

            $scope.isPlusType = function(qualifier) {
                return qualifier.value[0] == "+";
            };

            $scope.getColor = function(simulationResult) {
                if (simulationResult == Enum.STATE_OF_HEALTH_SIMULATION_ICF_ENTRY_SIMULATION_RESULT.BETTER) {
                    return "green";
                }
                if (simulationResult == Enum.STATE_OF_HEALTH_SIMULATION_ICF_ENTRY_SIMULATION_RESULT.WORSE) {
                    return "red";
                }
                return "blue";
            };
        }

        function configureInterface() {

        }

        function initialize() {
            stateOfHealthSimulationModel.get(visitCardId);
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);